// ignore-string-externalization

import { getAccessToken } from './accessTokenManager';

export async function tokenProvider(): Promise<[string, number]> {
  const [token] = await getAccessToken();
  if (!token) throw new Error('logged out');
  return [token, 0];
}
